"use strict";

var _classCallCheck = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _taggedTemplateLiteral = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  query TeamMemberPermissions {\n    system {\n      environmentMember {\n        email\n        permissions {\n          items {\n            resource\n            resourceType\n            permission\n          }\n        }\n        roles {\n          items {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  query UserPermissions {\n    user {\n      id\n      permissions {\n        items {\n          resource\n          resourceType\n          permission\n        }\n      }\n      roles {\n        items {\n          id\n          name\n        }\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var graphql_tag_1 = __importDefault(require("graphql-tag"));

var react_apollo_1 = require("react-apollo");

var auth_1 = require("@8base-react/auth");

var PermissionsContext_1 = require("./PermissionsContext");

var utils_1 = require("./utils");

var USER_PERMISSIONS_QUERY = graphql_tag_1.default(_templateObject());
var TEAM_MEMBER_PERMISSIONS_QUERY = graphql_tag_1.default(_templateObject2());
/**
 * Provider for 8base user permissions
 * @property {Function} children Children of the provider. Could be either react node or function with loading state.
 */

var PermissionsProvider = auth_1.withAuth(
/*#__PURE__*/
function (_react_1$default$Comp) {
  _inherits(PermissionsProvider, _react_1$default$Comp);

  function PermissionsProvider() {
    var _this;

    _classCallCheck(this, PermissionsProvider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PermissionsProvider).apply(this, arguments));

    _this.renderChildren = function (args) {
      var children = _this.props.children;

      if (typeof children === 'function') {
        return children(args);
      }

      return children;
    };

    _this.renderContent = function (_ref) {
      var data = _ref.data,
          loading = _ref.loading;
      var _this$props$type = _this.props.type,
          type = _this$props$type === void 0 ? 'teamMember' : _this$props$type;
      var permissions = utils_1.getPermissions(data, type);
      var roles = utils_1.getRoles(data, type);
      return react_1.default.createElement(PermissionsContext_1.PermissionsContext.Provider, {
        value: {
          permissions: permissions,
          roles: roles
        }
      }, _this.renderChildren({
        loading: loading
      }));
    };

    return _this;
  }

  _createClass(PermissionsProvider, [{
    key: "render",
    value: function render() {
      var _a = this.props,
          _a$auth = _a.auth,
          isAuthorized = _a$auth.isAuthorized,
          authState = _a$auth.authState,
          children = _a.children,
          type = _a.type,
          customQuery = _a.customQuery,
          rest = __rest(_a, ["auth", "children", "type", "customQuery"]);

      return react_1.default.createElement(react_apollo_1.Query, Object.assign({
        query: customQuery || (type === 'user' ? USER_PERMISSIONS_QUERY : TEAM_MEMBER_PERMISSIONS_QUERY),
        skip: !isAuthorized || !authState.workspaceId
      }, rest), this.renderContent);
    }
  }]);

  return PermissionsProvider;
}(react_1.default.Component));
exports.PermissionsProvider = PermissionsProvider;